import React, { useEffect } from "react";
import { Box } from "@mui/material";
import UltrasoundCustomSkeleton from "./UltrasoundCustomSkeleton";
import NoUltrasoundComponent from "./NoUltrasoundComponent";
import UltrasoundCard from "./UltrasoundCard";
import DataLoader from "../../../../components/custom-data-loader/DataLoader";
import { useGetUltraSoundImageQuery } from "../../services/GetUltraSoundImagesAPISlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { formatDisplayDate, getPatientRoute } from "../../../../utility/functions/common-functions";
import { useNavigate } from "react-router-dom";
import { setUltrasoundImages } from "../../services/GetUltrasoundImagesDataSlice";
import { parseUltrasoundImages } from "../../services/ParseUltrasoundImages";
import EmptyComponent from "../../../../components/v2/custom-empty-error-component/EmptyComponent";
import { useTranslation } from 'react-i18next';

const UltrasoundWidget: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const {
    data: ultarsoundData,
    isLoading,
    error: apiError,
  } = useGetUltraSoundImageQuery({});

  useEffect(() => {
    if (ultarsoundData) {
      dispatch(setUltrasoundImages(ultarsoundData.ultrasoundImages));
    }
  }, [dispatch, ultarsoundData]);

  const patientProfileId = useAppSelector(
    (state) => state.patientProfileDetails.patientProfileInfo.patientProfileId
  );

  const patientPreferredLang = useAppSelector(
    (state) => state.patientOnboardingStatus.preferredLanguage
  );
  const firstGroup = ultarsoundData?.ultrasoundImages?.[0];
  const navigate = useNavigate();
  const formattedUltrasoundData = firstGroup
  ? {
      imageDate: formatDisplayDate(firstGroup.imageDate, patientPreferredLang),
      imageCount: firstGroup.imageCount,
      imageDetails: parseUltrasoundImages(
        firstGroup.ultrasoundImages.slice(0, 2),
        firstGroup.imageDate, patientPreferredLang
      ),
    }
  : {
      imageDate: "",
      imageCount: 0,
      imageDetails: [],
    };
  
  const handleViewAll = () => {
    navigate(getPatientRoute(patientProfileId, "/ultrasound"), { state: { selectedTabId: 3 } });
  };
  return (
    <DataLoader
      isLoading={isLoading}
      error={apiError}
      data={ultarsoundData?.ultrasoundImages}
      loadingComponent={<UltrasoundCustomSkeleton />}
      emptyComponent={<NoUltrasoundComponent />}
      errorComponent={
        <EmptyComponent
          message={t("ultrasoundWidgetError")}
          textColor="error"
        />
      }    >
      {() => (
        <Box>
          <UltrasoundCard
            formattedData={formattedUltrasoundData}
            onViewAll={handleViewAll}
          />
        </Box>
      )}
    </DataLoader>
  );
};

export default UltrasoundWidget;
